export default (postalCode: string, postalCodePattern: string | string[]) => {
    // Stored patterns aren't always a plain string (e.g. legacy/imported settings saved as an array)
    if (Array.isArray(postalCodePattern)) {
        postalCodePattern = postalCodePattern.join(',')
    }

    if (typeof postalCode !== 'string' || typeof postalCodePattern !== 'string') {
        return false
    }

    const formattedPostalCode = postalCode.replace(/\s/g, '').toUpperCase()

    // Check if the postal code is in the correct format (4 digits followed by 2 letters)
    if (!/^[0-9]{4}[A-Z]{2}$/.test(formattedPostalCode)) {
        return false
    }

    const postalCodeNumbers = formattedPostalCode.substring(0, 4)
    const postalCodeLetters = formattedPostalCode.substring(4)

    return postalCodePattern.split(',').some((postalCodeRange) => {
        const postalCodeRangeStart = postalCodeRange.split('-')[0].replace(/\s/g, '').toUpperCase()
        let postalCodeRangeEnd = postalCodeRange.split('-')[1]?.replace(/\s/g, '').toUpperCase()

        // Check if the postal code range start is in the correct format
        if (!/^[0-9]{4}([A-Z]{2})?$/.test(postalCodeRangeStart)) {
            return false
        }

        const postalCodeRangeStartNumbers = postalCodeRangeStart.substring(0, 4)
        const postalCodeRangeStartLetters = postalCodeRangeStart.substring(4)

        // If there is no postal code range end, check if the postal code matches the postal code range start
        if (!postalCodeRangeEnd) {
            return postalCodeNumbers === postalCodeRangeStartNumbers && (!postalCodeRangeStartLetters || postalCodeRangeStartLetters === postalCodeLetters)
        }

        // Check if the postal code range start and end are in the correct format
        if (/^[A-Z]{2}$/.test(postalCodeRangeEnd)) {
            postalCodeRangeEnd = `${postalCodeRangeStartNumbers}${postalCodeRangeEnd}`
        }

        // Check if the postal code range end is in the correct format
        if (!/^[0-9]{4}([A-Z]{2})?$/.test(postalCodeRangeEnd)) {
            return false
        }

        const postalCodeRangeEndNumbers = postalCodeRangeEnd.substring(0, 4)
        const postalCodeRangeEndLetters = postalCodeRangeEnd.substring(4)

        if (postalCodeNumbers < postalCodeRangeStartNumbers || postalCodeNumbers > postalCodeRangeEndNumbers) {
            return false
        }

        if (postalCodeRangeStartLetters && postalCodeNumbers === postalCodeRangeStartNumbers && postalCodeLetters < postalCodeRangeStartLetters) {
            return false
        }

        if (postalCodeRangeEndLetters && postalCodeNumbers === postalCodeRangeEndNumbers && postalCodeLetters > postalCodeRangeEndLetters) {
            return false
        }

        return true
    })
}

// Generic matcher for countries other than NL: only the digits of the postal code are compared, without checking
// letters or a country-specific length. The pattern uses the same notation, e.g. "10000-19999, 20000"
export const matchNumericPostalCode = (postalCode: string, postalCodePattern: string) => {
    const postalCodeNumbers = postalCode.replace(/\D/g, '')

    if (!postalCodeNumbers) {
        return false
    }

    const postalCodeNumber = parseInt(postalCodeNumbers)

    return postalCodePattern.split(',').some((postalCodeRange) => {
        const postalCodeRangeStart = postalCodeRange.split('-')[0].replace(/\D/g, '')
        const postalCodeRangeEnd = postalCodeRange.split('-')[1]?.replace(/\D/g, '')

        if (!postalCodeRangeStart) {
            return false
        }

        if (!postalCodeRangeEnd) {
            return postalCodeNumber === parseInt(postalCodeRangeStart)
        }

        return postalCodeNumber >= parseInt(postalCodeRangeStart) && postalCodeNumber <= parseInt(postalCodeRangeEnd)
    })
}
